<template>
  <div>
    <CRow class="form-group">
      <CCol col="6">Username POS List </CCol>
    </CRow>
    <CDataTable
      hover
      striped
      :items="data"
      tableFilter
      :fields="fields"
      :items-per-page="10"
      clickable-rows
      :active-page="1"
      :pagination="false"
      @page-change="pageChange"
    >
      <template #updated_at="data">
        <td>
          <div class="button-table">
            <CButton
              color="primary"
              class="mb-0"
              @click="toDetailPage(data.item.id)"
              >Detail</CButton
            >
            <CButton
              color="warning"
              class="mb-0 ml-1"
              @click="toEditPage(data.item.id)"
              >Edit</CButton
            >
          </div>
        </td>
      </template>
    </CDataTable>
  </div>
</template>

<script>
export default {
  props: ["data", "isDetail", "memberPOSID"],
  data() {
    return {
      fields: [],
      query: "",
    };
  },
  methods: {
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    validateField() {
      if (this.isDetail) {
        this.fields = [
          { key: "pos_code", label: "POS Code", _style: "width:33%" },
          { key: "username", label: "Username", _style: "width:33%" },
          { key: "created_at", label: "Cretaed At", _style: "width:33%" },
        ];
      } else if (!this.isDetail) {
        this.fields = [
          { key: "pos_code", label: "POS Code", _style: "width:25%" },
          { key: "username", label: "Username", _style: "width:25%" },
          { key: "created_at", label: "Cretaed At", _style: "width:25%" },
          { key: "updated_at", label: "Action", _style: "width:25%" },
        ];
      }
    },
    toDetailPage(ID) {
         this.$router.push(`/management/member-pos/${this.memberPOSID}/username/detail/${ID}`);
    },
    toEditPage(ID) {
        this.$router.push(`/management/member-pos/${this.memberPOSID}/username/edit/${ID}`);
    },
  },
  mounted() {
    this.validateField();
  },
};
</script>